import { Box } from "@mui/material";
import dayjs from "dayjs";
import React from "react";

import { Typography } from "new-components/typography/Typography";

import { StartEndDateTimeProps } from "./types";

interface DateTabProps {
  label: string;
  valueTab: string;
  handleChange: () => void;
  dateValues: StartEndDateTimeProps;
}

export function DateTab(props: DateTabProps) {
  const { label, handleChange, valueTab, dateValues } = props;

  const isCurrentTab = valueTab === label;

  const existDate = dateValues.date === null ? "gray" : "black";

  return (
    <Box
      component="button"
      sx={{
        borderBottom: isCurrentTab ? "2px solid #0D297D" : "2px solid gray",
        padding: "0px 10px 10px 10px",
      }}
      className="cursor-pointer flex flex-col justify-start w-[50%] bg-inherit"
      onClick={handleChange}
    >
      <Typography
        fontWeight="bold"
        textTransform="uppercase"
        sx={{ color: isCurrentTab ? "#0D297D" : "black" }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: dateValues.date && isCurrentTab ? "#0D297D" : existDate,
        }}
      >
        {dateValues.date
          ? `${dayjs(dateValues.date).format("L")} ${dayjs(dateValues.time).format("HH:mm:ss")}`
          : "PLEASE SELECT"}
      </Typography>
    </Box>
  );
}
